// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"465a2302","22":"941976b3","49":"eb25523c","81":"dcd80c7e","223":"c95d81d2","325":"c5a7c72c","682":"e1d8e920","905":"24a8fc7e","967":"1b447f5a"}[chunkId] + ".chunk.js";
};